<template>
  <div class="flex flex-row border-b-4 border-yellow h-10 items-center">
    <app-year-selector color="yellow">
      <template v-slot:icon>
        <money-icn
          :class="['ml-3 mr-3 yellow-icon']"
          width="20px"
          height="20px"
          fill-rule="evenodd"
        ></money-icn>
      </template>
    </app-year-selector>
    <div class="w-full"></div>
    <div class="w-96 text-right">
      <span class="font-bold font-large text-yellow mr-3">総額</span>
      <span class="font-bold font-large text-yellow"
        >{{ sAmount.toLocaleString() }} 円</span
      >
    </div>
  </div>
</template>
<script>
import { ref, watch } from 'vue'
import AppYearSelector from '@/components/ui/AppYearSelector'
import MoneyIcn from '@/assets/icons/money-circle.svg?inline'
import { useBudgets } from '@/services/useBudgets'

export default {
  name: 'BudgetsTableHeader',

  components: {
    AppYearSelector,
    MoneyIcn,
  },

  setup() {
    const { budgets } = useBudgets()

    let sAmount = ref(0)
    const sumAmount = () => {
      sAmount.value = 0
      budgets.value.forEach(item => {
        sAmount.value = sAmount.value + item.amount
      })
    }
    watch(
      budgets,
      () => {
        sumAmount()
      },
      { deep: true },
    )
    return { sAmount, sumAmount }
  },
}
</script>
<style lang="scss"></style>
